import { render, staticRenderFns } from "./ShipmentDetailsAvailableSoon.vue?vue&type=template&id=6e58a946&"
import script from "./ShipmentDetailsAvailableSoon.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetailsAvailableSoon.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDetailsAvailableSoon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1751410358/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e58a946')) {
      api.createRecord('6e58a946', component.options)
    } else {
      api.reload('6e58a946', component.options)
    }
    module.hot.accept("./ShipmentDetailsAvailableSoon.vue?vue&type=template&id=6e58a946&", function () {
      api.rerender('6e58a946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/ShipmentDetailsAvailableSoon.vue"
export default component.exports